import { c as _c } from "react/compiler-runtime";
type ScoreGaugeProps = {
  score: number; // 0–100
  label?: string;
  size?: number;
};
const scoreColor = (s: number) => s <= 30 ? '#22c55e' : s <= 60 ? '#f59e0b' : s <= 80 ? '#f97316' : '#ef4444';
const scoreLabel = (s: number) => s <= 30 ? 'Low risk' : s <= 60 ? 'Medium risk' : s <= 80 ? 'High risk' : 'Critical risk';
const ScoreGauge = t0 => {
  const $ = _c(40);
  const {
    score: raw,
    label,
    size: t1
  } = t0;
  const size = t1 === undefined ? 160 : t1;
  const n = Number(raw);
  let t2;
  if ($[0] !== n) {
    t2 = Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : 0;
    $[0] = n;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const score = t2;
  const cx = size / 2;
  const r = size * 0.38;
  const cy = r + size * 0.04;
  const sw = size * 0.075;
  const h = cy + sw / 2 + size * 0.34;
  let t3;
  if ($[2] !== score) {
    t3 = scoreColor(score);
    $[2] = score;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const color = t3;
  const bgPath = `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${cx + r} ${cy}`;
  const angle = Math.PI * (score / 100);
  const ex = cx - r * Math.cos(angle);
  const ey = cy - r * Math.sin(angle);
  const fillPath = score > 0 ? `M ${cx - r} ${cy} A ${r} ${r} 0 0 1 ${ex} ${ey}` : null;
  let t4;
  if ($[4] !== label || $[5] !== score) {
    t4 = label || scoreLabel(score);
    $[4] = label;
    $[5] = score;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `${t4}: ${score} out of 100`;
  let t6;
  if ($[7] !== bgPath || $[8] !== sw) {
    t6 = <path d={bgPath} fill="none" stroke="rgba(148,163,184,0.15)" strokeWidth={sw} strokeLinecap="round" />;
    $[7] = bgPath;
    $[8] = sw;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== color || $[11] !== fillPath || $[12] !== sw) {
    t7 = fillPath && <path d={fillPath} fill="none" stroke={color} strokeWidth={sw} strokeLinecap="round" />;
    $[10] = color;
    $[11] = fillPath;
    $[12] = sw;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = cy + sw / 2 + size * 0.18;
  const t9 = size * 0.22;
  let t10;
  if ($[14] !== color || $[15] !== cx || $[16] !== score || $[17] !== t8 || $[18] !== t9) {
    t10 = <text x={cx} y={t8} textAnchor="middle" fontSize={t9} fontWeight="700" fill={color}>{score}</text>;
    $[14] = color;
    $[15] = cx;
    $[16] = score;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = cy + sw / 2 + size * 0.28;
  const t12 = size * 0.082;
  let t13;
  if ($[20] !== score) {
    t13 = scoreLabel(score).toUpperCase();
    $[20] = score;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== cx || $[23] !== t11 || $[24] !== t12 || $[25] !== t13) {
    t14 = <text x={cx} y={t11} textAnchor="middle" fontSize={t12} letterSpacing="0.06em" fill="rgba(100,116,139,0.85)">{t13}</text>;
    $[22] = cx;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== h || $[28] !== size || $[29] !== t10 || $[30] !== t14 || $[31] !== t5 || $[32] !== t6 || $[33] !== t7) {
    t15 = <svg width={size} height={h} role="img" aria-label={t5}>{t6}{t7}{t10}{t14}</svg>;
    $[27] = h;
    $[28] = size;
    $[29] = t10;
    $[30] = t14;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== label) {
    t16 = label && <p className="mt-1 text-center text-caption-1 text-tertiary">{label}</p>;
    $[35] = label;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t15 || $[38] !== t16) {
    t17 = <div className="flex flex-col items-center">{t15}{t16}</div>;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  return t17;
};
export default ScoreGauge;